import React from 'react';
import { motion } from "framer-motion"
import { portfolios } from "../data/portfolio.js"
import Carousel from './Carousel.jsx';
import PortfolioCard from './PortfolioCard.jsx';
const Portfolio = () => {

    return (
        <div name='Portfolio' className=" pt-20  text-white">
            <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-screen  h-full'>

                <div className='pb-8'>
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: true }}
                    >
                        <p className='text-4xl font-bold inline border-b-4 border-gray-400'>Projects</p>
                    </motion.div>
                </div>
                <div className='hidden sm:block bg-white/5 rounded-xl backdrop-blur-2xl'>
                    <div className='my-6 grid sm:grid-cols-2 md:grid-cols-3 w-full gap-8   px-6 md:px-12 overflow-y-auto sm:h-[36rem] h-[40rem] overflow-x-hidden'>
                        {portfolios.map(({ id, src, codeLink, viewLink, project, technology }) => (
                            <motion.div
                                key={id}
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.7, delay: 0.1 }}
                                viewport={{ once: true }} >

                                <PortfolioCard
                                    id={id}
                                    src={src}
                                    codeLink={codeLink}
                                    viewLink={viewLink}
                                    project={project}
                                    technology={technology}
                                />
                            </motion.div>
                        ))}
                    </div>
                </div>
                <div className='sm:hidden flex justify-center items-center mb-10'>
                        <Carousel
                            baseWidth={300}
                            autoplay={false}
                            autoplayDelay={3000}
                            pauseOnHover={true}
                            loop={true}
                            round={false}
                        />
                </div>
            </div>
        </div>
    );
}

export default Portfolio;
